import React from "react";

interface CustomScrollbarProps {
  show: boolean;
  thumbLeft: number;
  thumbWidth: number;
  onThumbMouseDown: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export const CustomScrollbar: React.FC<CustomScrollbarProps> = ({
  show,
  thumbLeft,
  thumbWidth,
  onThumbMouseDown,
}) => {
  if (!show) return null;

  return (
    <div className="relative h-2 bg-gray-100 border-t border-gray-200">
      <div
        className="absolute top-0 h-full bg-gray-400 rounded cursor-pointer hover:bg-gray-500 transition-colors"
        style={{
          left: `${thumbLeft}px`,
          width: `${thumbWidth}px`,
        }}
        onMouseDown={onThumbMouseDown}
      />
    </div>
  );
};
